/** External URLs used in navigation and CTAs */
export const CLIENT_PORTAL_URL = 'https://lidiana-cartolano.clientsecure.me/'
export const INSTAGRAM_URL = 'https://www.instagram.com/vivapsychotherapy'
